import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface SkillBarProps {
  name: string;
  level: number;
  color: 'teal' | 'orange' | 'purple' | 'green' | 'blue' | 'pink';
  delay?: number;
}
export function SkillBar({
  name,
  level,
  color,
  delay = 0
}: SkillBarProps) {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true
  });
  const colorClasses = {
    teal: 'bg-teal-500',
    orange: 'bg-orange-500',
    purple: 'bg-purple-500',
    green: 'bg-green-500',
    blue: 'bg-blue-500',
    pink: 'bg-pink-500'
  };
  return <div ref={ref} className="space-y-2" data-id="element-131">
      <div className="flex justify-between items-center" data-id="element-132">
        <span className="text-sm font-medium text-slate-300" data-id="element-133">{name}</span>
        <span className="text-xs font-mono text-slate-500" data-id="element-134">{level}%</span>
      </div>
      <div className="h-2 bg-slate-700/50 rounded-full overflow-hidden" data-id="element-135">
        <motion.div initial={{
        width: 0
      }} animate={isInView ? {
        width: `${level}%`
      } : {
        width: 0
      }} transition={{
        duration: 1.5,
        delay,
        ease: 'easeOut'
      }} className={`h-full ${colorClasses[color]} rounded-full`} data-id="element-136" />
      </div>
    </div>;
}